import React from 'react';

export interface AppleBlancoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const AppleBlancoIcon: React.FC<AppleBlancoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g fill="currentColor" filter="url(#a)"><path d="M5.012 12.823c-2.029 3.52-.739 8.864 1.505 12.103C7.637 26.546 8.77 28 10.324 28l.088-.002c.73-.029 1.257-.254 1.767-.47.573-.244 1.165-.497 2.093-.497.883 0 1.447.244 1.992.48.538.233 1.091.473 1.909.458 1.75-.033 2.823-1.602 3.77-2.986a13.2 13.2 0 0 0 1.653-3.384l.007-.021a.197.197 0 0 0-.119-.248c-.308-.126-3.01-1.325-3.039-4.592-.026-2.655 2.027-4.06 2.44-4.315l.019-.012a.196.196 0 0 0 .055-.277c-1.417-2.074-3.59-2.387-4.464-2.424a4 4 0 0 0-.39-.02c-1.027 0-2.011.389-2.802.7-.546.216-1.017.402-1.342.402-.366 0-.84-.188-1.389-.406-.734-.292-1.566-.622-2.447-.622h-.062c-2.048.03-3.984 1.203-5.05 3.059"/><path d="M18.497 4c-1.241.05-2.729.814-3.618 1.856-.756.875-1.494 2.335-1.3 3.807a.2.2 0 0 0 .18.17q.126.01.254.01c1.213 0 2.521-.671 3.415-1.751.94-1.141 1.416-2.605 1.272-3.917A.2.2 0 0 0 18.497 4"/></g><defs><filter id="a" width="32" height="32" x="-2.193" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_194_205123"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_194_205123" mode="multiply" result="effect2_dropShadow_194_205123"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_194_205123" result="shape"/></filter></defs>
    </svg>
  );
};

export default AppleBlancoIcon;
